import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { parseDateValue } from "../../classes/utils/DateUtils";
import { GET_PAIN_ASSESSMENTS_BY_IDS_QUERY } from "../../queries/painAssessmentQueries";

export function usePainAssessmentData(painAssessmentIds) {
  const { data, loading, error, refetch } = useQuery(
    GET_PAIN_ASSESSMENTS_BY_IDS_QUERY,
    {
      variables: { ids: painAssessmentIds },
      skip: !painAssessmentIds?.length,
      fetchPolicy: "network-only",
    }
  );

  const painAssessments = useMemo(() => {
    return data?.painAssessmentsByIds || [];
  }, [data]);

  const assessmentsByDate = useMemo(() => {
    // Create a copy of the array before sorting
    return [...painAssessments].sort(
      (a, b) =>
        (parseDateValue(b.createdAt)?.getTime() ?? 0) -
        (parseDateValue(a.createdAt)?.getTime() ?? 0)
    );
  }, [painAssessments]);

  const latestAssessment = useMemo(() => {
    return assessmentsByDate[0] || null;
  }, [assessmentsByDate]);

  return {
    painAssessments,
    assessmentsByDate,
    latestAssessment,
    loading,
    error,
    refreshPainAssessments: refetch,
  };
}
